<svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" aria-hidden="true"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <clipPath [attr.id]="uid + '-tc'"><path [attr.d]="towerGlyph"></path></clipPath>
    <filter [attr.id]="uid + '-lg'" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="1.6" result="b"></feGaussianBlur>
      <feMerge>
        <feMergeNode in="b"></feMergeNode><feMergeNode in="b"></feMergeNode>
        <feMergeNode in="SourceGraphic"></feMergeNode>
      </feMerge>
    </filter>
  </defs>

  <path [attr.d]="towerGlyph" [attr.fill]="color"></path>

  <!-- lattice truss (darker shade of the body), clipped to the silhouette. -->
  <g [attr.clip-path]="'url(#' + uid + '-tc)'">
    <path *ngFor="let l of towerMesh" [attr.d]="l" fill="none"
          [attr.stroke]="towerMeshColor" stroke-width="1.3" stroke-linecap="round"
          opacity="0.55"></path>
  </g>

  <rect *ngFor="let d of towerDecks" [attr.x]="d.x" [attr.y]="d.y" [attr.width]="d.w"
        [attr.height]="d.h" rx="1" [attr.fill]="color"></rect>

  <!-- ON: the decks light up — bright near-white lamps with a soft glow, and a
       few glowing twinkle-stars scatter in the negative space around the tower. -->
  <g *ngIf="on" [attr.filter]="'url(#' + uid + '-lg)'">
    <circle *ngFor="let l of towerLights" [attr.cx]="l.cx" [attr.cy]="l.cy"
            [attr.r]="l.r + 0.3" fill="#FFFCEF"></circle>
    <path *ngFor="let s of stars" [attr.d]="sparklePath"
          [attr.transform]="'translate(' + s.x + ',' + s.y + ') scale(' + s.s + ')'"
          fill="#FFF6D8"></path>
  </g>
</svg>
